module.exports = __webpack_public_path__ + "img/taste-parallax4.656dd9f9.jpg";